import React from 'react';
import { Section } from './ui/Section';
import { useCountdown } from '../hooks/useCountdown';
import { Button } from './ui/Button';
import { CtaFrame } from './ui/CtaFrame';
import { UrgencyBadge } from './ui/UrgencyBadge';
import { Clock } from 'lucide-react';
import { TropicalLeaf } from './botanical/TropicalLeaf';
import { CHECKOUT_URLS } from '../lib/checkoutLinks';
export function CTA4() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <Section className="bg-forest-deep text-cream-warm text-center py-24 relative overflow-hidden" data-id="element-207">
      <TropicalLeaf className="absolute -top-20 -right-20 w-96 h-96 text-moss opacity-15 blur-sm rotate-180" data-id="element-208" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-209">
        <CtaFrame variant="charcoal" data-id="element-210">
          <div className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-honey-light via-honey to-honey-dark text-forest-deep px-6 py-3 rounded-full font-bold uppercase tracking-wider mb-8 shadow-[0_0_30px_-5px_rgba(212,162,76,0.6)]" data-id="element-211">
            <Clock className="w-5 h-5" data-id="element-212" />
            EL PRECIO CIERRA EN: {hours} : {minutes} : {seconds}
          </div>

          <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto" data-id="element-213">
            <div className="bg-white/5 border-2 border-white/15 rounded-2xl p-6 flex flex-col items-center justify-center backdrop-blur-sm" data-id="element-214">
              <h3 className="font-serif font-bold text-xl mb-2 text-cream-warm" data-id="element-215">
                🌿 HOGAR NATURAL
              </h3>
              <div className="text-cream-warm/70 line-through text-sm mb-1" data-id="element-216">
                ANTES $34.000
              </div>
              <div className="text-3xl font-bold mb-6 text-cream-warm" data-id="element-217">
                HOY $17.999 <span className="text-lg font-normal" data-id="element-218">ARS</span>
              </div>
              <UrgencyBadge variant="clock" tone="light" label="CIERRA HOY" className="mb-3" data-id="element-219" />
              <Button variant="cta" size="lg" fullWidth href={CHECKOUT_URLS.hogarNatural} data-id="element-220">
                → EMPEZAR AHORA
              </Button>
            </div>

            <div className="bg-honey/10 border-2 border-honey rounded-2xl p-6 flex flex-col items-center justify-center relative backdrop-blur-sm shadow-[0_0_40px_-10px_rgba(212,162,76,0.6)]" data-id="element-221">
              <div className="absolute -top-3 bg-gradient-to-r from-honey-light to-honey-dark text-forest-deep text-xs font-bold px-3 py-1 rounded-full uppercase shadow-lg" data-id="element-222">
                ⭐ MÁS ELEGIDO
              </div>
              <h3 className="font-serif font-bold text-xl mb-2 text-cream-warm" data-id="element-223">
                SUPER PACK HOGAR NATURAL
              </h3>
              <div className="text-cream-warm/70 line-through text-sm mb-1" data-id="element-224">
                ANTES $58.000
              </div>
              <div className="text-3xl font-bold mb-6 text-cream-warm" data-id="element-225">
                HOY $27.999 <span className="text-lg font-normal" data-id="element-226">ARS</span>
              </div>
              <UrgencyBadge variant="fire" tone="light" label="OFERTA LIMITADA" className="mb-3" data-id="element-227" />
              <Button variant="cta" size="lg" fullWidth href={CHECKOUT_URLS.superPack} data-id="element-228">
                → QUIERO EL PACK COMPLETO
              </Button>
            </div>
          </div>
        </CtaFrame>
      </div>
    </Section>;
}